import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { TypeEntretientService } from 'src/app/_services/maintenance-service/type-entretient/type-entretient.service';
import { NotifService } from 'src/app/_services/notif.service';

@Component({
  selector: 'app-type-entretient-update',
  templateUrl: './type-entretient-update.component.html',
  styleUrls: ['./type-entretient-update.component.scss']
})
export class TypeEntretientUpdateComponent implements OnInit {
  TypeEntretientForm: FormGroup;
  isLoading = false;
  isError = false;
  isSuccess = false;
  isSubmitted = false;
  user

  typeEntretiens:any;

  constructor(
    private TypeEntretientService: TypeEntretientService,
    private notifService: NotifService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.user = this.authService.getUser();

    const type_Entretient_id = +this.route.snapshot.paramMap.get("id");
    this.TypeEntretientService.find(type_Entretient_id).then(
      data => {
        this.typeEntretiens = data;
        this.initForm(true);
      }
    ).catch(
      error => {
        this.translate.get('typeEntretiens.'+error.error.code)
        .subscribe(val => this.notifService.danger(val));
      }
    )
  }

  initForm(withTypeEntretient = false) {
    if(withTypeEntretient){
      this.TypeEntretientForm = this.formBuilder.group(
        {
          nom: [this.typeEntretiens.nom, [Validators.required]],
          description: [this.typeEntretiens.description],
        }
      );
      }
    else{
      this.TypeEntretientForm = this.formBuilder.group(
        {
          nom: ["", [Validators.required]],
          description: [""],
        }
      );
    }

  }

  get form() {
    return this.TypeEntretientForm.controls;
  }
  
  onSubmit() {
    console.log('on submit');
    this.isSubmitted = true;
    this.isError = false;
    this.isSuccess = false;
    this.isLoading = false;

    if (this.TypeEntretientForm.invalid) {
      this.translate.get('TypeEntretient.SubmitError')
        .subscribe(val => this.notifService.danger(val));
      return;
    }

    this.isLoading = true;
    const formData = new FormData();
    formData.append('nom', ''+this.form.nom.value);
    formData.append('description', ''+this.form.description.value);
    formData.append('create_id', '' + this.user.id);

      console.log(formData);
      this.TypeEntretientService.update(formData, this.typeEntretiens.id)
      .then(resp => {
        this.translate.get('TypeEntretient.SubmitSuccess')
        .subscribe(val => this.notifService.success(val));
        this.isSubmitted = false;
        this.TypeEntretientForm.reset();
        this.router.navigate(['/type-entretient/all'])

      })
      .catch(err => {
        console.log(err)
        this.translate.get('TypeEntretient.SubmitErrorTypeEntretient')
        .subscribe(val => this.notifService.danger(val));
      })
      .finally(() => this.isLoading = false);
  }
}
